import { useMemo } from "react";

import { useGetDictionaries } from "@synthesis/shared-services/internal/dictionaries/hooks";

import { buildReferenceWorkTypes, type ReferenceDictionaryItem } from "../reference-document-types-page.lib";

/**
 * Справочники ЛК администратора: базовый запрос GET /api/mdm/internal/api/internal/dictionaries
 * (та же ручка, что в форме создания заявки). На странице «Справочники» сейчас используется
 * раздел «Виды работ» (plannedWorksTypes).
 */
export const useReferenceDictionaries = () => {
  const query = useGetDictionaries({ query: { enabled: true } });

  const plannedWorksTypes = useMemo<ReferenceDictionaryItem[]>(() => buildReferenceWorkTypes(query.data?.plannedWorksTypes), [query.data]);

  return {
    plannedWorksTypes,
    isLoading: query.isLoading,
    isError: query.isError,
  };
};
